import React from 'react';
export const wrapContext = React.createContext();
export const modeContext = React.createContext();
